module.exports = __webpack_public_path__ + "static/com_JRP-684d47d9d023afe3511d9e6096c5dde8.png";